import type RootState from 'app-components/utils/redux-store/rootState';
import { shallowEqual } from 'react-redux';
import { createSelector, createSelectorCreator, lruMemoize, weakMapMemoize } from 'reselect';

// use if you only need your selector in one component
export const createAppSelector = createSelector.withTypes<RootState>();

// Use if you need your selector in multiple components with different args
export const createWeakMapSelector = createSelectorCreator({
  memoize: weakMapMemoize,
  argsMemoize: weakMapMemoize,
});

// Use if you need your selector in multiple components with heavy computation and different arguments (eg reports)
export const createSelectorShallowEqual = createSelectorCreator({
  memoize: lruMemoize,
  memoizeOptions: {
    equalityCheck: shallowEqual,
    resultEqualityCheck: shallowEqual,
    maxSize: 10,
  },
  argsMemoize: lruMemoize,
  argsMemoizeOptions: {
    equalityCheck: shallowEqual,
    resultEqualityCheck: shallowEqual,
    maxSize: 10,
  },
});

// https://reselect.js.org/api/lrumemoize/
//
// NOTE: You can always add your own custom equality checks. Here is an example:
// const selectTodoIds = createAppSelector(
//   [(state: RootState) => state.todos],
//   todos => todos.map(todo => todo.id),
//   {
//     memoize: lruMemoize,
//     memoizeOptions: {
//       equalityCheck: (a, b) => a.firstProperty === b.firstProperty,
//       resultEqualityCheck: (a, b) => a.firstProperty === b.firstProperty,,
//       maxSize: 10
//     },
//     argsMemoize: lruMemoize, // this is for memoizing arguments, it is optional
//     argsMemoizeOptions: {
//       equalityCheck: (a, b) => a.firstProperty === b.firstProperty,,
//       resultEqualityCheck: (a, b) => a.firstProperty === b.firstProperty,,
//       maxSize: 10
//     }
//   }
// )
